import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { PinsState } from "./types";
import { Pins } from "../../pages/mainPage/Statistics/Map/Pins/types";

const initialState: PinsState = {
  data: null,
  loading: false,
  error: null,
  pinsForSelectedCountry: null,
};

export const fetchPinsDataAsync = createAsyncThunk(
  "pins/fetchPinsData",
  async (year: string) => {
    return await api.getPins(year);
  }
);

const pinsSlice = createSlice({
  name: "pins",
  initialState,
  reducers: {
    resetPins: (state) => {
      state.pinsForSelectedCountry = null;
    },
    setPinsForSelectedCountry: (state, action: PayloadAction<Pins | null>) => {
      state.pinsForSelectedCountry = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPinsDataAsync.pending, (state) => {
        state.data = null;
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPinsDataAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPinsDataAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to fetch pin data";
      });
  },
});

export const { resetPins, setPinsForSelectedCountry } = pinsSlice.actions;
export default pinsSlice.reducer;
